'use client'

import { Pattern1 } from "@/(front-desk)/utils/patterns"

const pageList = {
    '最新消息': {
        'home': '/news/all',
        'sub-page': {
            '所有訊息': '/news/all',
            '訊息公告': '/news/announcement',
            '系列講座': '/news/lecture',
        }
    },
    '參展專區': {
        'home': '/exhibit',
        'sub-page': {
            '首頁': '/exhibit',
        }
    },
    '競賽專區': {
        'home': '/compete',
        'sub-page': {
            '首頁': '/compete',
        }
    },
    '展覽資訊': {
        'home': '/information',
        'sub-page': {
            '參觀資訊': '/information/about',
            '交通資訊': '/information/transportation',
            '展覽活動資訊': '/information/activities',
            '活動時間表': '/information/time-table',
        }
    },
    '下載專區': {
        'home': '/download',
        'sub-page': {
            '得獎名單': '/download/winners',
            '大會公告': '/download/handbook',
            '作業辦法': '/download/procedure',
            '得獎標章': '/download/medal',
        }
    },
    '其他': {
        'home': '/sitemap',
        'sub-page': {
            '常見問題': '/faq',
            '熱情贊助': '/sponsor',
            '隱私權及資訊安全政策': '/privacy',
            '著作權聲明': '/copyright'
        }
    }
}
export default function sitemap() {
    return (
        <>
        <title>網站導覽 - 放視大賞</title>
        <main className="sponsor">
            <div className="page-banner py-16">
                <div className="page-banner-content flex justify-between items-center">
                    <div>
                        <h1 className="title">Guide</h1>
                        <h2 className="sub-title">網站導覽</h2>
                    </div>
                    <Pattern1 className="fill-main w-[4.5rem]" />
                </div>
            </div>
            <div id="main" className="content pb-10">
                <div className="flex flex-wrap gap-[3rem]">
                    { Object.keys(pageList).map((page, index) => {
                        return (
                            <div key={`page-${page}`} className="bg-black-900 rounded-[1.25rem] p-6 sm:w-[16.875rem] w-full">
                                <div className="w-full mb-3 pb-3 border-b border-black-700">
                                    <a
                                        className="text-[1.5rem] text-main font-semibold hover:text-main-700 trasition duration-300"
                                        href={pageList[page].home}
                                    >{page}</a>
                                </div>
                                <ul className="ps-6 list-disc">
                                    { Object.keys(pageList[page]['sub-page']).map((subPage, index) => {
                                        return (
                                            <li
                                                key={`sub-page-${subPage}`}
                                                className="my-2 text-white font-light hover:text-black-700 trasition duration-300"
                                            ><a href={pageList[page]['sub-page'][subPage]}>{subPage}</a></li>
                                        )
                                    })}
                                </ul>
                            </div>
                        )
                    })}
                </div>
            </div>
        </main>
        </>
    )
}